import { render } from "./BasePriceText.vue?vue&type=template&id=5b67a2a6&ts=true"
import script from "./BasePriceText.vue?vue&type=script&lang=ts"
export * from "./BasePriceText.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__